import { useEffect, useState } from "react";
import Input from "../../blocks/Input"
import { useForm } from "../../hooks/useForm";
import './profile.css'
import { Link, useLocation } from "react-router-dom";
import { ajax } from "../../scripts/helper";
import utils from "../../scripts/utils";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useSnackbar } from 'notistack'
import { useNavigate } from "react-router-dom"
import { useSearchParams } from "react-router-dom"





const ProfileFrom = ({header , data, type}) =>{
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { state } = useLocation()

  const [currencyValue, setCurrencyValue] = useState()
  const [inputCurrencyValue, setInputCurrencyValue] = useState('');
  const [currencyOptions, setCurrencyOptions] = useState([]);

  const [cityValue, setCityValue] = useState()
  const [inputCityValue, setInputCityValue] = useState('');
  const [cityOptions, setCityOptions] = useState([]);


  const [accountsOption, setAccountsOption] = useState([])

  const [accountValue, setAccountValue] = useState([])

  const [readOnly, setReadOnly] = useState(false)

  const {enqueueSnackbar} = useSnackbar()



  


  const [inputFields, handleChange, setInputFields] = useForm({
      name: {
        name: "name",
        value: "",
        type: "text",
        placeholder: "office name",
      },
      officeCode: {
        name: "officeCode",
        value: "",
        type: "text",
        placeholder: "R12345",
      },
      email: {
        name: "email",
        value: "",
        type: "text",
        placeholder: "agency@example.com",
      },
      phone: {
        name: "phone",
        value: "",
        type: "text",
        placeholder: "(+237) 696 88 77 55",
      },
      accounting: {
        name: "accounting",
        value: "",
        type: "number",
        placeholder: "10001",
      },
      iata: {
        name: "iata",
        value: "",
        type: "text",
        placeholder: "THR",
      },
      contactPerson: {
        name: "contactPerson",
        value: "",
        type: "text",
        placeholder: "Manager name ...",
      },
      mobile: {
        name: "mobile",
        value: "",
        type: "text",
        placeholder: "0912 *** ** **",
      },
      city: {
        name: "city",
        value: "",
        type: "select",
        selected: null,
        items: [],
        icon: <i className="icon-Star-1"></i>,
      },
      address: {
        name: "address",
        value: "",
        type: "text",
        placeholder: "Street, Avenue, Alley, Plaque",
      },
      currency: {
        name: "currency",
        value: "",
        type: "select",
        items: [],
        selected: null
      },
      economicCode: {
        name: "economicCode",
        value: "",
        type: "text",
        placeholder: 'economic code'
      }
  });



      const createOffice = async() => {
        let accounts = []
        for(const acc of accountValue) {
          accounts.push(acc.id)
        }

        console.log(accounts, 'acccccc')

        const data = {
          "code": inputFields.officeCode.value,
          "name": inputFields.name.value,
          "iata": inputFields.iata.value,
          "currencyId": inputFields.currency.selected,
          "cityId": inputFields.city.selected,
          "contactPerson": inputFields.contactPerson.value,
          "phone": inputFields.phone.value,
          "mobile": inputFields.mobile.value,
          "email": inputFields.email.value,
          "address": inputFields.address.value,
          "accountNo": parseInt(inputFields.accounting.value),
          "accounts": accounts,
          "economicCode": inputFields.economicCode.value,
          "paymentStatus": "ACTIVE",
          "status": "ACTIVE"
        }

        console.log(data, 'data office create')

        const res = await ajax({
          method: 'POST',
          url: utils.urls.createOffice,
          hasToken: true,
          snackbar: enqueueSnackbar,
          data
        })

        console.log(res, 'this is offic create response')

        navigate('/agent/offices')
      }


      const updateOffice = async() => {

        let accounts = []
        for(const acc of accountValue) {
          accounts.push(acc.id)
        }

        const data = {
          "code": inputFields.officeCode.value,
          "name": inputFields.name.value,
          "iata": inputFields.iata.value,
          "currencyId": inputFields.currency.selected,
          "cityId": inputFields.city.selected,
          "contactPerson": inputFields.contactPerson.value,
          "phone": inputFields.phone.value,
          "mobile": inputFields.mobile.value,
          "email": inputFields.email.value,
          "address": inputFields.address.value,
          "accountNo": parseInt(inputFields.accounting.value),
          "accounts": accounts,
          "economicCode": inputFields.economicCode.value,
          "paymentStatus": "ACTIVE",
          "status": "ACTIVE"
        }

        const res = await ajax({
          method: 'PUT',
          url: utils.urls.updateOffice(state.id),
          hasToken: true,
          snackbar: enqueueSnackbar,
          data
        })

        if(!res) return

        navigate('/agent/offices')
        

      }

      const fetchCurrency = async() => {

        const response = await ajax({
            method: 'GET',
            url: utils.urls.serachCurrency(inputCurrencyValue),
            hasToken: true,
            snackbar: enqueueSnackbar
        })
        console.log(response)

        if(!response) return

        setCurrencyOptions(response.data)

      }


      const fetchCity = async() => {

        const response = await ajax({
            method: 'GET',
            url: utils.urls.searchCity(inputCityValue),
            hasToken: true,
            snackbar: enqueueSnackbar
        })
        console.log(response)

        if(!response) return

        setCityOptions(response.data)
    }


    const fetchAccounts = async() => {
      const res = await ajax({
        method: 'GET',
        url: utils.urls.accountsList,
        hasToken: true,
        snackbar: enqueueSnackbar
      })

      if(!res) return

      setAccountsOption(res.data)
    }

    const fillData = async () => {

      console.log(data, 'dataaaaaddsdsdsdssdsd')

      setInputFields({
        ...inputFields,
        name:{
          ...inputFields.name,
          value: data?.name
        },
        officeCode: {
          ...inputFields.officeCode,
          value: data?.code
        },
        email: {
          ...inputFields.email,
          value: data?.email
        },
        phone: {
          ...inputFields.phone,
          value: data?.phone
        },
        mobile: {
          ...inputFields.mobile,
          value: data?.mobile
        },
        accounting: {
          ...inputFields.accounting,
          value: data?.accountNo
        },
        iata: {
          ...inputFields.iata,
          value: data?.iata
        },
        contactPerson: {
          ...inputFields.contactPerson,
          value: data?.contactPerson
        },
        address: {
          ...inputFields.address,
          value: data?.address
        },
        economicCode: {
          ...inputFields.economicCode,
          value: data?.economicCode
        },
        currency: {
          ...inputFields.currency,
          value: state.currency,
          selected: state.currency.id
        },
        city: {
          ...inputFields.city,
          value: data?.city,
          selected: data?.city?.id
        }

      })

      if(data) {

        setAccountValue(data.accounts)
        setAccountsOption(data.accounts)
      }
      if(type === 'edit') fetchAccounts()
   
    }

      useEffect( () => {
        if(type === 'create') fetchAccounts()

        if(type === 'edit' || type === 'detail')  fillData()

        if(type === 'detail') setReadOnly(true)
        
      },[data])

      useEffect( () => {
        if(inputCurrencyValue.trim()) fetchCurrency()
        
      }, [inputCurrencyValue])      
      
      useEffect( () => {
        if(inputCityValue.trim()) fetchCity()
        
      }, [inputCityValue])      

    return (
        <>
            {/* {
                type == "edit" && 
                <div className="edit-btn">
                    <button className="delete">Delete Office</button>
                    <button className="save">Save changes</button>
                </div>
            } */}
            
            <div className="form-container__header">Office Information</div>
            <div className="form-container__inputs">
                <div className="row">
                <div className="officeId">
                    <label>Office Code</label>
                    <Input
                    className="extra"
                    inputField={inputFields.officeCode}
                    onChange={handleChange}
                    readOnly={readOnly}
                    />
                </div>
                <div className="officeCode">
                    <label>Office Name</label>
                    <Input
                    className="extra"
                    inputField={inputFields.name}
                    onChange={handleChange}
                    readOnly={readOnly}

                    />
                </div>
                </div>
                <div className="row">
                <div className="officeId">
                    <label>Email Address</label>
                    <Input
                    className="extra"
                    inputField={inputFields.email}
                    onChange={handleChange}
                    readOnly={readOnly}

                    />
                </div>
                <div className="officeCode">
                    <label>Office Phone Number</label>
                    <Input
                    className="extra"
                    inputField={inputFields.phone}
                    onChange={handleChange}
                    readOnly={readOnly}

                    />
                </div>
                </div>
                <div className="row">
                  <div className="officeId">
                      <label>Accounting Code</label>
                      <Input
                      className="extra"
                      inputField={inputFields.accounting}
                      onChange={handleChange}
                      readOnly={readOnly}

                      />
                  </div>
                  <div className="officeCode">
                      <label>IATA Code</label>
                      <Input
                      className="extra"
                      inputField={inputFields.iata}
                      onChange={handleChange}
                      readOnly={readOnly}

                      />
                  </div>
                </div>
                <div className="row">
                  <div className="officeId">
                      <label>Economic Code</label>
                      <Input
                      className="extra"
                      inputField={inputFields.economicCode}
                      onChange={handleChange}
                      readOnly={readOnly}

                      />
                  </div>
                  <div className="officeCode">
                    <label>Currency</label>
                  <Autocomplete 
                    sx={{ width: "100%" }}
                    renderInput={(params) => <TextField {...params} />}
                    getOptionLabel={ (option) =>  option ? option.code : ''}
                    options={currencyOptions}
                    autoComplete
                    includeInputInList
                    filterSelectedOptions
                    value={inputFields.currency.value}
                    noOptionsText="No currency"
                    onChange={(event, newValue) => {
                        setCurrencyValue(newValue?.id);
                        setInputFields({
                            ...inputFields,
                            currency: {
                                ...inputFields.currency,
                                selected: newValue?.id,
                                value: newValue
                            }
                        })
                        console.log(newValue)
                    }}
                    onInputChange={(event, newInputValue) => {
                        if(newInputValue.trim())
                            setInputCurrencyValue(newInputValue)
                    }}
                    renderOption={(props, option) => <li {...props}>{option.code}</li>}
                    readOnly={readOnly}

                  />
                  </div>
                </div>
                <div className="row" style={{marginBottom: "10px"}}>
                    <div className="officeId" style={{width: "95.5%"}}>
                      <label>Accounts</label>
                    <Autocomplete
                      multiple
                      id="tags-outlined"
                      options={accountsOption}
                      getOptionLabel={(option) => option.name}
                      // defaultValue={[]}
                      value={accountValue}
                      filterSelectedOptions
                      renderInput={(params) => (
                        <TextField
                          {...params}
                        />
                      )}
                      onChange={(event , newValue) => {
                        console.log(event , 'lllll', newValue)
                        setAccountValue(newValue)
                      }}
                      readOnly={readOnly}

                    />
                    
                    </div>
                </div>

                <div className="line"></div>
                <div className="form-container__header">Contact Person</div>
                <div className="row" style={{marginBottom: "10px"}}>
                <div className="officeId">
                    <label>contact</label>
                    <Input
                    className="extra"
                    inputField={inputFields.contactPerson}
                    onChange={handleChange}
                    readOnly={readOnly}

                    />
                </div>
                <div className="officeCode">
                    <label>Mobile Number</label>
                    <Input
                    className="extra"
                    inputField={inputFields.mobile}
                    onChange={handleChange}
                    readOnly={readOnly}

                    />
                </div>
                </div>
                <div className="line"></div>
                <div className="form-container__header">Address Information</div>
                <div className="row">
                <div className="city">
                    <label>City</label>
                    <Autocomplete 
                    sx={{ width: "100%" }}
                    renderInput={(params) => <TextField {...params} />}
                    getOptionLabel={ (option) =>  option ? option.code : ''}
                    options={cityOptions}
                    autoComplete
                    includeInputInList
                    filterSelectedOptions
                    value={inputFields.city.value}
                    noOptionsText="No city"
                    onChange={(event, newValue) => {
                        setCityValue(newValue?.id);
                        setInputFields({
                            ...inputFields,
                            city: {
                                ...inputFields.city,
                                selected: newValue?.id,
                                value: newValue
                            }
                        })
                        console.log(newValue)
                    }}
                    onInputChange={(event, newInputValue) => {
                        if(newInputValue.trim())
                            setInputCityValue(newInputValue)
                    }}
                    renderOption={(props, option) => <li {...props}>{option.code}</li>}
                    readOnly={readOnly}

                />
                </div>
                <div className="address">
                    <label>Full Address</label>
                    <Input
                    className="extra"
                    inputField={inputFields.address}
                    onChange={handleChange}
                    readOnly={readOnly}

                    />
                </div>
                </div>
                <div className="row">
                    <div className="city">
                    
                    </div>
                </div>
                {
                    type == 'create' &&
                    <div className="button">
                        <Link to={'/agent/offices'}>
                          <button className="cancel">Cancel</button>
                        </Link>
                        <button className="submit" onClick={createOffice}>Save Office</button>
                    </div>

                }
                {
                  type === 'edit' &&
                  <div className="office-edit-btn">
                      <button className="delete" onClick={()=> navigate('/agent/offices')}>Back</button>
                      <button className="save" onClick={() => updateOffice()}>Save changes</button>
                  </div>
                }
            </div>
        </>
    )


}

export default ProfileFrom